import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import { ElConfigProvider } from 'element-plus';
import { useCommon } from '@/store/useCommon';
import i18n from '@/i18n/index';
import { getArrByReduce } from '@/utils/tools';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      messages,
      locale
    } = i18n.global;
    const storeCommon = useCommon();
    // 当前的语言环境
    const currentLang = computed(() => {
      let lang = storeCommon.lang;
      locale.value = lang;
      return messages.value[lang];
    });
    const showComponent = computed(() => storeCommon.showComponent);
    const excludePage = computed(() => storeCommon.excludePage);
    const includePage = computed(() => storeCommon.includePage);
    const pageInclude = computed(() => getArrByReduce(storeCommon.sportVisitedViews, 'name'));
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_unref(ElConfigProvider), {
          locale: _unref(currentLang)
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            include: _unref(includePage),
            exclude: _unref(excludePage)
          }, [_unref(showComponent) ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _unref(route).name
          })) : _createCommentVNode("", true)], 1032, ["include", "exclude"]))]),
          _: 2
        }, 1032, ["locale"])]),
        _: 1
      });
    };
  }
});